import React, { useState,useEffect } from "react";
import PropTypes from "prop-types";
import { API_BASE } from "../config/env";
import axios from "axios";
import InLineError from "./InLineError";
import { useHistory } from "react-router-dom";
import styles from "./CreditCardForm.module.css";
import Cards from "react-credit-cards";
import {formatCardNumber, formatCVC, formatExpirationDate} from "../utils/paymentUtil";
import InputMask from 'react-input-mask';

import {formatMsisdn} from "../utils/helperUtil";
import {Header,Modal} from "semantic-ui-react";
import Helper from "./Helper";


function CreditCardForm(props) {
  let history = useHistory();

  const [msisdn, setMsisdn] = useState("");
  const [name, setName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [errors, setErrors] = useState("");
  const [token, setToken] = useState("");
  const [threeDSessionId, setThreeSessionId] = useState("");
  const [threeDSessionResult, setThreeDSessionResult] = useState("");
  const [personName, setPersonName] = useState("");
  const [personSurname, setPersonSurname] = useState("");
  const [tckn, setTckn] = useState("");
  const [address, setAddress] = useState("");

  const [cvc, setCvc] = useState("");
  const [expiry, setExpiry] = useState("");
  const [focus, setFocus] = useState("");
  const [issuer, setIssuer] = useState("");
  const [open3Dmodal, setOpen3Dmodal] = useState(false);
    const [omccSecureUrl, setOmccSecureUrl] = useState("");
    const [getTokenUrl, setGetTokenUrl] = useState("");
    const [ip, setIP] = useState('');
    const {getTrackingId ,checkSession} = Helper();

    useEffect(async() => {
            const response1 = await fetchOmccSecureUrl();
            const response2 = await fetchTokenUrl();
            await getIpAddressV2();
        },        []
    );

    useEffect(() => {
        setThreeSessionId(threeDSessionId);
    },[threeDSessionId])

    const fetchOmccSecureUrl = async () => {
        const param ='KFO_SDK_OMCC_3D_SECURE_URL'
        const result = await fetchParam(param);
        if (result.data) {
            setOmccSecureUrl(result.data.parameterValue)
        }
    };

    const getIpAddress = async () => {
        const res = await axios.get('https://geolocation-db.com/json/')
        setIP(res.data.IPv4)
    }

    const getIpAddressV2 = async () => {
        const res = await axios.get("https://api.ipify.org/?format=json");
        setIP(res.data.ip);
    };

    const fetchTokenUrl = async () => {
        const param ='KFO_SDK_OMCC_GET_TOKEN_URL'
        const result = await fetchParam(param);
        if (result.data) {
            setGetTokenUrl(result.data.parameterValue)
        }
    };

    const fetchParam = async (param) => {
        const reqParam = {
            paramName: param,
        };
        try {
            const response = await axios.post(`${API_BASE}/getParam`,reqParam,{
                headers: {
                    'Content-Type': 'application/json'
                }
            }).catch((error) => console.log(error));
            if (response.status === 200) {
                // response -    object, eg { status: 200, message: 'OK' }
                return response;
            }

            return false;
        } catch (error) {
            return error;
        }
    };


  CreditCardForm.propTypes = {
    getToken: PropTypes.func,
    payment: PropTypes.object,
    invoice: PropTypes.object.isRequired,
    acceptTermCOHS: PropTypes.bool.isRequired,
    acceptTermKSS: PropTypes.bool.isRequired,
    checkAcceptTermCOHS: PropTypes.func.isRequired,
    checkAcceptTermKSS: PropTypes.func.isRequired,
    payingStatusChange: PropTypes.func.isRequired,
    setServiceMessage: PropTypes.func.isRequired,
    setMessageOpen: PropTypes.func.isRequired
  };

  const getAndSession = async () => {
      const tokenResponse = await getToken();
      if (typeof tokenResponse != "undefined" && tokenResponse != false ) {
         if (tokenResponse.data.operationResultCode == 0) {
             setToken(tokenResponse.data.token);
             //token geldi. 3dsecure e git:
             const sessionIdResponse = await get3DSessionId(tokenResponse.data.token);
             if (typeof sessionIdResponse != "undefined" && sessionIdResponse != false){
                 await checkSession(sessionIdResponse.data.operationResult)
                 if (sessionIdResponse.data.operationResult.resultCode == 0) {
                     setThreeSessionId(sessionIdResponse.data.threeDsessionId);
                     return {token : tokenResponse.data.token,
                             sessionId: sessionIdResponse.data.threeDsessionId };
                 }
            } else {
             props.setServiceMessage("Bağlantı hatası. Lütfen daha sonra tekrar deneyiniz.");
            props.setMessageOpen(true);
            return ;
            }
         } else {
             props.setServiceMessage(tokenResponse.data.operationResultDescription);
             props.setMessageOpen(true);
             return ;
         }
      } else {
          props.setServiceMessage("Bağlantı hatası. Lütfen daha sonra tekrar deneyiniz.");
          props.setMessageOpen(true);
          return ;
        }

  }


  const onSubmit = async (e) => {
    e.preventDefault();
    const errors = validate();
    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      props.payingStatusChange(true);

      const result = await getAndSession();

       if (typeof result == "undefined"){
            props.payingStatusChange(false);
            return ;
       }

      // const tokenResponse = await getData();
      // setToken(tokenResponse.data.token);
      // setThreeSessionId(tokenResponse.data.threeDSessionId);
      //

      let threedCheck = 0;
      setOpen3Dmodal(true);
      document.getElementById("sessionId").submit();

      let threedResultResponse;
      do {
        threedResultResponse = await get3dResult(
          result.sessionId
        );
        if (threedResultResponse.data.currentStep == "3" || threedResultResponse.data.currentStep == "1" ) {
          if (threedResultResponse.data.mdStatus != "1" && threedResultResponse.data.mdStatus != "Y") {
              history.push({
              pathname: "/result",
              state: {
                invoice: props.invoice,
                  callerMsisdn: formatMsisdn(msisdn),
                paymentResult: {
                  operationResult: {
                    resultCode: "99999",
                    resultDesc: "3D Doğrula başarısız.",
                  },
                },
              },
            });
          } else if (threedResultResponse.data.threeDOperationResult.threeDResult == "0") {
              const paymentResponse = await makePayment(
              result.sessionId,
                  result.token
            );
            if (
              paymentResponse &&
              paymentResponse.data &&
              paymentResponse.data.operationResult
            ) {
                const responseData = paymentResponse.data;

              history.push({
                pathname: "/result",
                state: {
                  invoice: props.invoice,
                    callerMsisdn: formatMsisdn(msisdn),
                  paymentResult: responseData,
                },
              });
            } else {
                history.push({
                pathname: "/result",
                state: {
                  invoice: props.invoice,
                    callerMsisdn: formatMsisdn(msisdn),
                  paymentResult: paymentResponse,
                },
              });
            }
          } else {
              history.push({
              pathname: "/result",
              state: {
                invoice: props.invoice,
                callerMsisdn: formatMsisdn(msisdn),
                paymentResult: {
                  operationResult: {
                    resultCode: threedResultResponse.data.threeDOperationResult.threeDResult,
                    resultDesc: "3D Doğrula başarısız.",
                  },
                },
              },
            });
          }
        }
      } while (
        threedResultResponse.data.operationResult !== null &&
        threedResultResponse.data.operationResult !== "undefined" &&
        (threedResultResponse.data.currentStep == "0" ||
          threedResultResponse.data.currentStep == "2")
      );
      props.payingStatusChange(false);
    }
  };

  const update3DResult = (state) => {
    setThreeDSessionResult(state, () => {
      props.callback(threeDSessionResult);
    });
  };

  const getData = async () => {
    let databody = {
      ccNo: cardNumber,
      expiry: expiry,
      amount: props.invoice.totalAmount,
      msisdn: formatMsisdn(msisdn),
        corpCode:props.invoice.corpCode
    };

    try {
      const response = await axios.post(`${API_BASE}/getToken`, databody);
      if (response.status === 200) {
        // response - object, eg { status: 200, message: 'OK' }
        return response;
      }
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  };



  const getToken = async () => {
      let databody = await createTokenInput();
    try {
      const response = await axios.post(`${getTokenUrl}`, databody,{
      'Content-Type': 'text/plain'
        });
      if (response.status === 200) {
        // response - object, eg { status: 200, message: 'OK' }
        return response;
      }
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const createTokenInput = async () => {
      const monthyear = expiry.split('/');
      const month = monthyear[0];
      const year = monthyear[1]

      let text1 = "<ccRequest>";
      let result = text1.concat("","<ccNo>",cardNumber.replace(/\s/g, ""),"</ccNo>",
          "<expDateMonth>",month,"</expDateMonth>",
          "<expDateYear>",year,"</expDateYear>",
          "</ccRequest>")
      return result
  }


  const get3DSessionId = async (token) => {

      let databody = {
      token: token,
      amount: props.invoice.totalAmount,
      msisdn: formatMsisdn(msisdn),
      corpCode:props.invoice.corpCode,
      installmentCount : props.invoice.installmentCount,
      invoiceId:props.invoice.invoiceRefNo,
      customerPaymentMethod: props.invoice.customerPaymentMethod,
      trackingId:getTrackingId(),
      donationAmount:props.invoice.donationAmount
      };
    try {
      const response = await axios.post(`${API_BASE}/get3DsessionId`, databody);
      if (response.status === 200) {
        // response - object, eg { status: 200, message: 'OK' }
        return response;
      }
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  };



  const get3dResult = async (threeDSessionId) => {
      const reqParam = {
      threeDSessionId: threeDSessionId,
      corpCode: props.invoice.corpCode
    };

    try {
      const response = await axios
        .post(`${API_BASE}/getThreeDSessionResult`, reqParam)
        .catch((error) => console.log(error));
      if (response.status === 200) {
        // response -    object, eg { status: 200, message: 'OK' }
        return response;
      }
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const makePayment = async (threeDSessionId, token) => {
    const requestBody = {
      corpCode: props.invoice.corpCode,
      corpName: props.invoice.corpName,
      currency: props.invoice.currency,
      subscriberNo: props.invoice.subscriberNo,
      subscriberName: props.invoice.subscriberName,
      invoiceDueDate: props.invoice.invoiceDueDate,
      invoiceAmount: props.invoice.invoiceAmount,
      bankRefNo: props.invoice.bankRefNo,
      invoiceInfo1: props.invoice.invoiceInfo1,
      invoiceInfo2: props.invoice.invoiceInfo2,
      invoiceInfo3: props.invoice.invoiceInfo3,
      invoiceNo: props.invoice.invoiceNo,
      invoiceRefNo: props.invoice.invoiceRefNo,
      invoiceSeqNo: props.invoice.invoiceSeqNo,
      invoiceStatus: props.invoice.invoiceStatus,
      newInstallmentAmount: props.invoice.newInstallmentAmount,
      commissionAmount: props.invoice.commissionAmount,
      paymentAmount: props.invoice.totalAmount,
      msisdn: formatMsisdn(msisdn),
      threeDSessionId: threeDSessionId,
      token: token,
      customerPaymentMethod: props.invoice.customerPaymentMethod,
      isDonationDo: props.invoice.isDonationDo,
      vendorDonatId:props.invoice.vendorDonatId,
      donationAmount:props.invoice.donationAmount,
      donationId:props.invoice.donationId,
      ipAddress: ip,
      trackingId: getTrackingId(),
      personName: personName,
      personSurname: personSurname,
      tckn: tckn,
      address: address
    };

    try {
      const response = await axios
        .post(`${API_BASE}/payInvoice`, requestBody)
        .catch((error) => console.log(error));

      if (response.status === 200) {
          await checkSession(response.data.operationResult);
          return response;
      }
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const validate = () => {
    const errors = {};
/*    if (!props.acceptTermCOHS) {
      errors.acceptTermCOHSStatus = props.acceptTermCOHS;
      errors.acceptTermCOHS = "Çerçeve sözleşmesini kabul etmeniz gerekmektedir.";
      props.checkAcceptTermCOHS(errors);
    }
    if (!props.acceptTermKSS) {
      errors.acceptTermKSSStatus = props.acceptTermKSS;
      errors.acceptTermKSS = "Kart saklama sözleşmesi kabul etmeniz gerekmektedir.";
      props.checkAcceptTermKSS(errors);
    }*/

    if (!msisdn || formatMsisdn(msisdn).length < 10) errors.msisdn = "Geçerli Telefon numarası giriniz.";
    if (!name) errors.name = "Kartin üzerindeki isim boş olamaz.";
    if (!cardNumber) errors.cardNumber = "Kart numarası boş olamaz.";
    if (!expiry || expiry.length < 5 ) errors.expiry = "Kartın son kullanma tarihini giriniz.";
    if (!cvc || expiry.length < 3) errors.cvc = "CVC Kodunu giriniz.";
    if(!personName) errors.personName = "İsim boş olamaz.";
    if(!personSurname) errors.personSurname = "Soyisim boş olamaz.";
    if(!tckn) errors.tckn = "TC kimlik numarası boş olamaz.";
    if(!address) errors.address = "Adres boş olamaz.";
    if (!isValidTCKN(tckn)) errors.tckn = "Geçersiz TC kimlik numarası";
    return errors;
  };

  const handleCallback = ({ issuer }, isValid) => {
    if (isValid) {
      setIssuer(issuer);
    }
  };

  const handleExpiryChange = ({ target }) => {
    if (target.name === "expiry") {
      target.value = formatExpirationDate(target.value);
    }
    setExpiry(target.value);
  };

  const handleCvcChange = ({ target }) => {
    if (target.name === "cvc") {
      target.value = formatCVC(target.value);
    }
    setCvc(target.value);
  };

  const handleCardNumberChange =  ({ target }) => {
    if (target.name === "number") {
      target.value = formatCardNumber(target.value);
    }
    if (target.value.length == 7){
        checkCardForInstallment(target.value,null);
    } else if (target.value.length < 7){
        props.invoice.installmentCount=0
        props.installmentStatusChange(false);
    } else {
        if (target.value.length == 19){
            if (cardNumber.substring(0, 7) != target.value.substring(0, 7)){
                checkCardForInstallment(target.value.substring(0, 7),null);
            }
        }
    }
    setCardNumber(target.value);
  };


    const checkCardForInstallment = async (binValue, token) => {
        const requestBody = {
            binValue: binValue,
            token: token
        };

        try {
            const response = await axios
                .post(`${API_BASE}/checkCardForInstallment`, requestBody)
                .catch((error) => console.log(error));
            if (response.status === 200) {
                props.installmentStatusChange(response.data.cardMakeInstallment)
                if (!response.data.cardMakeInstallment){
                    props.invoice.installmentCount=0
                }
                return response;
            }
            return false;
        } catch (err) {
            console.error(err);
            return false;
        }
    };

  const isValidTCKN = (tckn) => {
    const value = tckn.toString();
    var isEleven = /^[0-9]{11}$/.test(value);
    var totalX = 0;
    for (var i = 0; i < 10; i++) {
      totalX += Number(value.substr(i, 1));
    }
    var isRuleX = totalX % 10 == value.substr(10,1);
    var totalY1 = 0;
    var totalY2 = 0;
    for (var i = 0; i < 10; i+=2) {
      totalY1 += Number(value.substr(i, 1));
    }
    for (var i = 1; i < 10; i+=2) {
      totalY2 += Number(value.substr(i, 1));
    }
    var isRuleY = ((totalY1 * 7) - totalY2) % 10 == value.substr(9,0);
    return isEleven && isRuleX && isRuleY;
  };

  const handleTcknChange = (e) => {
    const value = e.target.value;
    setTckn(value);
    if (value.length === 0) {
      setErrors({ ...errors, tckn: "TC kimlik numarası boş olamaz" });
    }

    if (!isValidTCKN(value)) {
        setErrors({ ...errors, tckn: "Geçersiz TC kimlik numarası" });
    } else {
        setErrors({ ...errors, tckn: null });
    }
  };

  const local = { valid: 'S.K.T.'
  };

  const placeholders = {
    name: 'AD SOYAD'
  };

  return (
    <div>
      <form
        id="sessionId"
        name="sessionId"
        onSubmit={(e) => onSubmit(e)}
        target="my-iframe"
        action={omccSecureUrl}
        method="POST"
        encType="application/json"
        className={styles.contactForm}
      >
        <div>
          <h2>İletişim Bilgileri</h2>
        </div>
        <div>


         <InputMask
            id="msisdn"
            name="msisdn"
          value={msisdn}
          onChange={(e) => setMsisdn(e.target.value)}
          mask="(599) 999 99 99"
          maskChar="_"
        />
          {errors.msisdn && <InLineError message={errors.msisdn} />}
          <label htmlFor="msisdn">Ödeme yapacak kişinin GSM No</label>
        </div>
        <div>
          <input
            id="personName"
            name="personName"
            type="text"
            value={personName}
            onChange={(e) => setPersonName(e.target.value)}
            onFocus={(e) => setFocus(e.target.personName)}
            placeholder=" "
          />
          {errors.personName && <InLineError message={errors.personName}/>}
          <label htmlFor="personName">İsim</label>
        </div>
        <div>
          <input
            id="personSurname"
            name="personSurname"
            type="text"
            value={personSurname}
            onChange={(e) => setPersonSurname(e.target.value)}
            onFocus={(e) => setFocus(e.target.personSurname)}
            placeholder=" "
          />
          {errors.personSurname && <InLineError message={errors.personSurname}/>}
          <label htmlFor="personSurname">Soyisim</label>
        </div>
        <div>
          <input
            id="tckn"
            name="tckn"
            type="text"
            value={tckn}
            onChange={handleTcknChange}
            maxLength="11"
            placeholder=" "
          />
          {errors.tckn && <InLineError message={errors.tckn}/>}
          <label htmlFor="tckn">TC Kimlik Numarası</label>
        </div>
        <div>
          <h4 style={{
            textAlign: "left", fontWeight: "normal", marginLeft: "18px"
          }}>Adres</h4>
        </div>
        <div>
          <textarea
            id="address"
            name="address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            onFocus={(e) => setFocus(e.target.address)}
            placeholder=""
            rows={5}
            cols={35}
          />
          {errors.address && <InLineError message={errors.address}/>}
        </div>
        <div>
          <h2>Kart Bilgileri</h2>
        </div>

        <div>
          <Cards
            number={cardNumber}
            name={name}
            expiry={expiry}
            cvc={cvc}
            focused={focus}
            callback={handleCallback}
            locale={local}
            preview={true}
            placeholders={placeholders}
          />
        </div>
        <br/>
        <div>

          <input
            id="name"
            name="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onFocus={(e) => setFocus(e.target.name)}
            placeholder=" "
          />
                {errors.name && <InLineError message={errors.name} />}
          <label htmlFor="name">Kart Üzerindeki İsim</label>
        </div>
        <div>

          <input
            id="cardNumber"
            name="number"
            value={cardNumber}
            type="tel"
            pattern="[\d| ]{16,22}"
            onChange={handleCardNumberChange}
            onFocus={(e) => setFocus(e.target.name)}
            placeholder=" "
          />
                {errors.cardNumber && <InLineError message={errors.cardNumber} />}
          <label htmlFor="cardNumber">Kart Numarası</label>
        </div>


        <div>

        <InputMask
            id="expiry"
            name="expiry"
          value={expiry}
          onChange={handleExpiryChange}
          mask="99 / 99"
          maskChar="_"
        />
        {errors.expiry && <InLineError message={errors.expiry} />}
          <label htmlFor="expiry">Son Kullanma Tarihi</label>
        </div>

        <div style={{paddingBottom: "30px"}}>

          <input
            id="cvc"
            name="cvc"
            value={cvc}
            onChange={handleCvcChange}
            onFocus={(e) => setFocus(e.target.name)}
            onBlur={(e) => setFocus("name")}
            placeholder=" "
          />
                {errors.cvc && <InLineError message={errors.cvc} />}
          <label htmlFor="cvc">CVC Kodu</label>
        </div>

        <input type="hidden" id="token" name="token" value={token} />
        <input
          type="hidden"
          id="threeDSessionId"
          name="threeDSessionId"
          value={threeDSessionId}
        />
      </form>

        <Modal
        basic
        size='small'
        dimmer='blurring'
        closeOnDimmerClick={false}
        open={open3Dmodal}
        onClose={() => setOpen3Dmodal(false)}
        onOpen={() => setOpen3Dmodal(true)}
        id='my-modal'
      >
        <Header content= "3D Onay Sayfası" />
        <Modal.Content>
          <iframe name="my-iframe" src={omccSecureUrl} width="400px" height="400px" ></iframe>
        </Modal.Content>
      </Modal>
    </div>
  );
}

export default CreditCardForm;
